/** 최근 24시간 안에 바뀐 메뉴에 붙는 표식. 사이드바와 홈 위젯이 같이 쓴다. */
export function NewBadge() {
  return (
    <span
      style={{
        fontSize: '10px',
        fontWeight: 700,
        color: 'white',
        background: '#ef4444',
        borderRadius: '999px',
        padding: '1px 6px',
        lineHeight: 1.5,
      }}
    >
      New
    </span>
  );
}
